"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
/**
 * HTTP Status Codes used in the Syla API.
 *
 * Consumers of the API should only use status codes to determine:
 * - 2XX = success
 * - 4XX = client calling the api made an error
 * - 5XX = server made an error processing the request
 *
 * Application logic should not be based on error status codes, instead, the
 * error code should be used.
 */
exports.Status = {
    /**
     * The request was successful, and there is a response body (it can still be
     * empty if there is nothing to return though).
     */
    Ok: 200,
    /**
     * The request has been successfully accepted for async processing.
     */
    Accepted: 202,
    /**
     * The request was successful and there is no response body.
     */
    NoContent: 204,
    /**
     * The request was formatted incorrectly when it was sent to the API, or
     * the request was validly formed, but it could not be processed due to a
     * validation error or other limitation.
     */
    BadRequest: 400,
    /**
     * We don't know who you are, authenticate first to prove identity.
     *
     * Only use this on unauthenticated users, as it can trigger special handling
     * which is part of the re-auth flows.
     */
    Unauthorized: 401,
    /**
     * We know who you are, but you don't have access to do this.
     */
    Forbidden: 403,
    /**
     * The thing requested couldn't be found.
     */
    NotFound: 404,
    /**
     * We couldn't accept this request as it conflicts with the current state
     * on the resource. e.g. we don't allow concurrent async processes.
     */
    Conflict: 409,
    /**
     * User uploaded an unsupported file type, e.g. a PDF file, where we are
     * expecting a CSV file.
     */
    UnsupportedMediaType: 415,
    Locked: 423,
    /**
     * Unexpected error in our B/E processing of the request.
     */
    InternalServerError: 500,
    /**
     * An upstream partner API failed.
     */
    BadGateway: 502,
};
